import { useContext, useMemo, useState } from "react";
import { UserContext } from "contexts/UserContext/UserContext";
import { IEventReportDetails } from "entities/EventReports/EventReportsEntityInterfaces";
import { DetailsReportEditionContext } from "contexts/DetailsReportEditionContext/DetailsReportEditionContext";
import { NotesField } from "../SegmentFields";

/**
 * Inline-edit adapter: binds the controlled NotesField to the
 * DetailsReportEditionContext for the table's row edit.
 */
export const NoteTextfield = ({ row }: { row: IEventReportDetails }) => {
    const { user_id } = useContext(UserContext);
    const { edit, setEdit } = useContext(DetailsReportEditionContext);

    const existingEdition = useMemo(() => edit.findIndex((event) => event.id === row.event_report_id), [edit, row]);
    const notesChanges = useMemo(() => edit[existingEdition]?.changes?.notes, [edit, existingEdition]);
    const [notes, setNotes] = useState<string>(notesChanges || "");

    const handleNotesUpdate = (value: string) => {
        setNotes(value);
        if (existingEdition === -1) return;
        setEdit((prevEdit) => {
            const newEdit = [...prevEdit];
            newEdit[existingEdition] = {
                ...newEdit[existingEdition],
                changes: {
                    ...newEdit[existingEdition]?.changes,
                    notes: value,
                    ...(user_id && { edited_by_user_id: user_id }),
                },
            };
            return newEdit;
        });
    };

    return <NotesField value={notes} onChange={handleNotesUpdate} />;
};
